import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import {
    showUserDetail
} from './../../redux/slicers/userSlice';
import { showPortfolioDetail } from './../../redux/slicers/portfolioSlice';
import MembershipBadge from './../MembershipBadge';

const UserBox = (props) => {
    const user = props.user;
    const navigate = useNavigate();

    const dispatch = useDispatch();

    const avatar = user.avatar !== null && user.avatar !== "" ? user.avatar : 'https://via.placeholder.com/300x300';

    const viewDetail = (id) => {
        dispatch(showPortfolioDetail(null));
        dispatch(showUserDetail(id)); // ✅ Set selectedUserId in Redux
        navigate(`/arsitek/${id}`);
    };

    return (
        <div
            style={{
            }}>
            <div className="box" onClick={() => viewDetail(user.id)} style={{
                padding: '0px',
                marginBottom: '20px',
                overflow: 'hidden',
                cursor: 'pointer',
            }}>
                <div className="p-3">
                    <img src={avatar} alt="user avatar" style={{
                        width: '100%',
                        borderRadius: '5px',
                    }} />
                </div>
                <div className='text-center p-2 mb-1'>
                    <p style={{
                        fontSize: '12pt',
                        fontWeight: 'bold',
                        cursor: 'pointer',
                        marginBottom: 10,
                        textTransform: 'capitalize',
                    }}>{user.first_name + ' ' + user.last_name}</p>
                    <MembershipBadge membershipType={user.membership_type} membershipLabel={user.membership_name} />
                    {user.skills && user.skills.trim() !== '' ? (
                        <div className="mt-4 text-center">
                            <p className="mb-1" style={{ fontWeight: "bold" }}>Spesialisasi</p>
                            <p style={{ color: "#AA272F", fontSize: "14px" }}>
                                {user.skills
                                    .split(',')
                                    .map(skill => skill.trim())
                                    .join(', ')}
                            </p>
                        </div>
                    ) : (
                        <div style={{ height: '48px' }}></div> // add placeholder height to keep balance
                    )}

                </div>
            </div>
        </div>
    );
}

export default UserBox;